export default "__VITE_ASSET__CB9KP$bw__"